import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  // 1. Check if user already accepted cookies when page loads
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay for smooth entrance animation
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500 fade-in">
      <div className="max-w-6xl mx-auto bg-gray-900/95 backdrop-blur-md text-white p-6 rounded-2xl shadow-2xl border border-gray-800 flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* TEXT SECTION */}
        <div className="flex items-start md:items-center gap-5">
          <div className="p-3 bg-gray-800 rounded-full shrink-0">
            <Cookie size={28} className="text-yellow-400" />
          </div>
          <div>
            <h4 className="font-bold text-lg mb-1">Wir verwenden Cookies 🍪</h4>
            <p className="text-sm text-gray-300 leading-relaxed max-w-2xl">
              Wir nutzen Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. 
              Durch die Nutzung unserer Seite stimmen Sie der Verwendung von Cookies zu. 
              <a href="/datenschutz" className="underline hover:text-white ml-1 transition-colors">
                Datenschutzerklärung
              </a>.
            </p>
          </div>
        </div>

        {/* BUTTONS SECTION */}
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
          <button 
            onClick={handleDecline}
            className="px-6 py-2.5 rounded-xl text-sm font-semibold text-gray-300 hover:text-white hover:bg-gray-800 border border-gray-700 transition-all duration-200"
          >
            Ablehnen
          </button>
          <button 
            onClick={handleAccept}
            className="px-8 py-2.5 rounded-xl text-sm font-bold text-white shadow-lg hover:scale-105 hover:shadow-red-500/20 transition-all duration-200"
            style={{ backgroundColor: '#ff4a4a' }}
          >
            Akzeptieren
          </button>
        </div>

      </div>
    </div>
  );
};

export default CookieConsent;